module.exports = __webpack_public_path__ + "img/web-vitals-logo.4e1b0382.svg";